var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "UpgradeModal", role: "dialog", "data-backdrop": "static" },
    },
    [
      _c("div", { staticClass: "modal-dialog upgrade-account-modal" }, [
        _c(
          "div",
          { staticClass: "modal-content first-modal-content" },
          [
            _c("div", { staticClass: "modal-header upgradeModal-bgcolor" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "data-target": "#UpgradeModal" },
                  on: { click: _vm.closePopup },
                },
                [_vm._v(" × ")]
              ),
              _c("div", { staticClass: "modal-title" }, [
                _c("div", { staticClass: "upgrade-service-para" }, [
                  _vm.addonType === "service"
                    ? _c("span", [_vm._v("Upgrade Add-on(s)")])
                    : _vm._e(),
                  _vm.addonType === "account"
                    ? _c("span", [_vm._v("Upgrade Account Add-on(s)")])
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "modal-body confirm-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _vm.addonType === "service"
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-7 col-md-7 col-sm-7 text-left",
                          },
                          [
                            _c("div", { staticClass: "upgrade-team" }, [
                              _vm._v("Upgrade Records"),
                            ]),
                            _c("div", { staticClass: "current-limit" }, [
                              _vm._v(" (Current Limit: "),
                              _vm.records.total_limit >
                                _vm.records.default_limit &&
                              _vm.records.is_active &&
                              _vm.todayDate() < _vm.records.valid_until &&
                              _vm.todayDate() >= _vm.records.valid_from
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.records.total_limit) + " "
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.records.default_limit)),
                                  ]),
                              _vm._v(" ) "),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-lg-5 col-md-5 col-sm-5 pl-0" },
                          [
                            _c("div", { staticClass: "additional-price" }, [
                              _vm._v(" Price: "),
                              _vm.selectedRecords.name !== "250 & 2GB"
                                ? _c("span", [_vm._v("Additional")])
                                : _vm._e(),
                              _vm._v(
                                " " + _vm._s(_vm.selectedRecords.desc) + " "
                              ),
                            ]),
                            _c("multiselect", {
                              staticClass:
                                "multiselect-single-dropdown multiselect-service",
                              attrs: {
                                "show-labels": false,
                                "allow-empty": false,
                                searchable: false,
                                "open-direction": "bottom",
                                options: _vm.options,
                                label: "name",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "singleLabel",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "option_name" },
                                          [_vm._v(_vm._s(props.option.name))]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "option",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "option_name" },
                                          [_vm._v(_vm._s(props.option.name))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2552770966
                              ),
                              model: {
                                value: _vm.selectedRecords,
                                callback: function ($$v) {
                                  _vm.selectedRecords = $$v
                                },
                                expression: "selectedRecords",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.addonType === "account" && _vm.teamMember
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-7 col-md-7 col-sm-7 text-left",
                          },
                          [
                            _c("div", { staticClass: "upgrade-team" }, [
                              _vm._v("Upgrade Team Members"),
                            ]),
                            _c("div", { staticClass: "current-limit" }, [
                              _vm._v(" (Current Limit: "),
                              _c("span", [_vm._v(_vm._s(_vm.teamLimit) + ")")]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-lg-5 col-md-5 col-sm-5 pl-0" },
                          [
                            _vm.team_member.price > 0
                              ? _c("div", { staticClass: "additional-price" }, [
                                  _vm._v(" Price: "),
                                  _vm._v(
                                    " " + _vm._s(_vm.team_member.desc) + " "
                                  ),
                                ])
                              : _vm._e(),
                            _c("multiselect", {
                              staticClass:
                                "multiselect-single-dropdown multiselect-account",
                              class: !_vm.team_member ? "un-selected" : "",
                              attrs: {
                                "show-labels": false,
                                "allow-empty": false,
                                searchable: false,
                                "open-direction": "bottom",
                                options: _vm.team_members,
                                label: "label",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "singleLabel",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "option_name" },
                                          [_vm._v(_vm._s(props.option.label))]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "option",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "option_name" },
                                          [_vm._v(_vm._s(props.option.label))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1451000022
                              ),
                              model: {
                                value: _vm.team_member,
                                callback: function ($$v) {
                                  _vm.team_member = $$v
                                },
                                expression: "team_member",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "row mt-20" }, [
                _c("div", { staticClass: "col-lg-12 text-center" }, [
                  _vm.addonType === "service" &&
                  _vm.selectedService &&
                  _vm.selectedService.service_type !== "premium"
                    ? _c("div", { staticClass: "account-charges" }, [
                        _c("span", { staticClass: "reg-tracker-star" }, [
                          _vm._v("*"),
                        ]),
                        _c("span", [
                          _vm._v(
                            "Additional charges for an upgrade are waived during a free trial. The base price plus upgrades will be billed once your free trial expires."
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.addonType === "service" &&
                  _vm.selectedService &&
                  _vm.selectedService.service_type === "premium"
                    ? _c("div", { staticClass: "account-charges" }, [
                        _c("span", { staticClass: "reg-tracker-star" }, [
                          _vm._v("*"),
                        ]),
                        _vm._m(0),
                      ])
                    : _vm._e(),
                  _vm.addonType === "account"
                    ? _c("div", { staticClass: "account-charges" }, [
                        _c("span", { staticClass: "reg-tracker-star" }, [
                          _vm._v("*"),
                        ]),
                        _vm._m(1),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "modal-footer cancelModal-bgcolor" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-6 col-sm-6 col-md-6 p-0 text-left please-cancel-btn",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn emergo-white-button wd-custom",
                      on: {
                        click: function ($event) {
                          return _vm.closePopup()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "col-lg-6 col-sm-6 col-md-6 p-0 text-right" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn emergo-blue-button wd-custom",
                      on: { click: _vm.upgradeSubscription },
                    },
                    [
                      _vm._v(" Upgrade "),
                      _vm.addonType === "account"
                        ? _c("span", [_vm._v("Account")])
                        : _vm._e(),
                      _vm.addonType !== "account"
                        ? _c("span", [_vm._v("Service")])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]),
            _c("error-modal", { attrs: { errorMessage: _vm.errorMessage } }),
            _c("success-modal", {
              attrs: { successMessage: _vm.successMessage },
              on: { closeParent: _vm.closePopup },
            }),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Charges for add-ons may be prorated to align with validity "),
      _c("br"),
      _vm._v(" of the corresponding Premium Service"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Charges for add-ons may be prorated to align with validity "),
      _c("br"),
      _vm._v(" of a previous Team Member upgrade"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }